import React, { useState } from "react";
import Header from "../../components/Header/Header";
import SideBar from "../../components/SideBar/AdminSideBar";
import ClassSessions from "./ClassSessions";
import { Link } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import CourseSidebar from "../../components/SideBar/CourseSidebar";
import { hooks } from "../../studentportal-sdk";

const LiveStream = (props) => {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    title: "",
    description: "",
    startDate: "",
    endDate: "",
    imageUrl: "",
    allowedRegions: [], // added for allowed regions
  });

  const availableRegions = ["Randborg", "Sandton", "Midrand", "Soweto", " Limpopo"]; // Example regions 

  const handleCreateSessionClick = () => {
    setShowForm((prev) => !prev);
  };

  const handleImageChange = async (e) => {
    const files = e.target.files;
    const formData = new FormData();
    formData.append("file", files[0]);
    formData.append("upload_preset", "joqtcy5z");

    try {
      const res = await axios.post(
        `https://api.cloudinary.com/v1_1/dbklykh2o/image/upload`,
        formData
      );
      const cloudinaryUrl = res.data.secure_url;
      setForm((prev) => ({
        ...prev,
        imageUrl: cloudinaryUrl,
      }));
    } catch (error) {
      console.error("Error uploading image to Cloudinary:", error);
    }
  };

  const {
    liveSessionService: {
      store: { liveClassDoc },
      action: { scheduleLiveClass },
    },
  } = props;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  const onSubmit = (data) => {
    if (data)
      scheduleLiveClass({
        ...data,
        imageUrl: form.imageUrl,
        allowedRegions: form.allowedRegions,
      }) && setShowForm(false);
  };

  const handleRegionChange = (e) => {
    const { value, checked } = e.target;
    setForm((prev) => {
      const updatedRegions = checked
        ? [...prev.allowedRegions, value]
        : prev.allowedRegions.filter((region) => region !== value);
      return { ...prev, allowedRegions: updatedRegions };
    });
  };

  const role = localStorage.getItem("role");

  return (
    <>
      <div className="main-wrapper">
        <Header />
        {role === "admin" && <SideBar />}
        {role === "user" && <CourseSidebar />}
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <h3 className="page-title">Live Session</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Live Session</li>
                  </ul>
                </div>
              </div>
            </div>

            {role === "admin" && (
              <div className="row mb-3">
                <div className="col">
                  <button
                    className="btn btn-primary"
                    onClick={handleCreateSessionClick}
                  >
                    {showForm ? "Cancel" : "Create Live Session"}
                  </button>
                </div>
              </div>
            )}

            {showForm && (
              <div className="row">
                <div className="col">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                      <label htmlFor="sessionTitle">Class Title</label>
                      <Controller
                        name="title"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <input
                            className={`form-control ${
                              errors?.title ? "error-input" : ""
                            }`}
                            type="text"
                            value={value}
                            onChange={onChange}
                            autoComplete="off"
                          />
                        )}
                        defaultValue=""
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="sessionTitle">Class Description</label>
                      <Controller
                        name="description"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <input
                            className={`form-control ${
                              errors?.description ? "error-input" : ""
                            }`}
                            type="text"
                            value={value}
                            onChange={onChange}
                            autoComplete="off"
                          />
                        )}
                        defaultValue=""
                      />
                    </div>
                    <div className="form-group">
                      <label> Image Url</label>
                      <div className="change-photo-btn">
                        <div>
                          <p>Add Image</p>
                        </div>
                        <input
                          name="imageUrl"
                          type="file"
                          className="upload"
                          accept="image/*"
                          onChange={handleImageChange}
                        />
                      </div>

                      <div className="mt-2">
                        {form.imageUrl && (
                          <img
                            src={form.imageUrl}
                            alt="Cover"
                            width={100}
                            className="me-2"
                          />
                        )}
                      </div>
                    </div>

                    {/* Allowed Regions */}
                    <div className="form-group">
                      <label>Allowed Regions</label>
                      <div className="checkbox-group">
                        {availableRegions.map((region) => (
                          <div key={region} className="form-check">
                            <input
                              type="checkbox"
                              id={region}
                              value={region}
                              checked={form.allowedRegions.includes(region)}
                              onChange={handleRegionChange}
                              className="form-check-input"
                            />
                            <label htmlFor={region} className="form-check-label">
                              {region}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Start Date</label>
                      <Controller
                        name="startDate"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <input
                            type="date"
                            className={`form-control ${
                              errors?.startDate ? "error-input" : ""
                            }`}
                            value={value}
                            onChange={onChange}
                          />
                        )}
                        defaultValue=""
                      />
                      <small className="text-danger">
                        {errors?.startDate?.message}
                      </small>
                    </div>
                    <div className="form-group">
                      <label>End Date</label>
                      <Controller
                        name="endDate"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <input
                            type="date"
                            className={`form-control ${
                              errors?.endDate ? "error-input" : ""
                            }`}
                            value={value}
                            onChange={onChange}
                          />
                        )}
                        defaultValue=""
                      />
                      <small className="text-danger">
                        {errors?.endDate?.message}
                      </small>
                    </div>

                    <button type="submit" className="btn btn-success">
                      Create Session
                    </button>
                  </form>
                </div>
              </div>
            )}

            <div className="row">
              <ClassSessions liveClassDoc={liveClassDoc} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
/* eslint-disable */
export default (props) => <LiveStream {...hooks.liveSession(props)} />;
